/**
 * @fileoverview Notifications component to display various types of notifications
 * with optional actions and progress indicators. This component is used primarily
 * in BKTools in place of a regular toast notification system.
 *
 * Notifications are created using the Angular NotificationsService, which
 * provides a notify function that accepts a message and options for the notification.
 */

import React from 'react';
import { StyledNotifications } from './Notifications.styles';
import { LoadingSpinner } from 'loading-spinner';

interface NotificationItem {
  id?: number;
  type?: string;
  text?: string;
  percent?: number;
  action?: () => void;
  actionText?: string;
}

interface NotificationsProps {
  notifications?: NotificationItem[];
}

const Notifications: React.FC<NotificationsProps> = ({ notifications = [] }) => {
  return (
    <StyledNotifications>
      <div className="notifications">
        {notifications.map((notification, index) => {
          const type = notification.type ?? 'default';
          const hasAction = Boolean(notification.action);

          return (
            <div
              className={`notification type-${type} ${hasAction ? 'hasAction' : ''} bl-animate`}
              key={notification.id ?? index}
            >
              <div
                data-testid={`bl-notification-${index}-${type}`}
                className="notification-content"
              >
                {type === 'loading' ? <LoadingSpinner /> : null}
                <div className="icon"></div>
                <span className="text">{notification.text}</span>
                <div className="progress">
                  <div
                    className="progress-bar"
                    style={{ width: `${notification.percent ?? 0}%` }}
                  ></div>
                </div>
              </div>
              {notification.action && (
                <button className="notification-action" type="button" onClick={notification.action}>
                  {notification.actionText}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </StyledNotifications>
  );
};

export default Notifications;
